import React from "react";
import ReactPlayer from "react-player";
import "./VideoHeader.css"; // Create a CSS file for styling

const VideoHeader = () => {
  return (
    <div className="video-header-container">
      <ReactPlayer
        url="forest.mp4"
        playing={true}
        loop={true}
        muted={true}
        width="100%"
        height="100%"
      />
      <div className="overlay">
        <div className="video-content">
          <h1>Bonobo Hope Initiative</h1>
          <p>Bringing a fresh perspective on great apes</p>
        </div>
      </div>
    </div>
  );
};

export default VideoHeader;
